module.exports = __webpack_public_path__ + "static/media/pendig.cc6270ca.svg";